import './popupPayment.css'
import React, {useEffect, useState} from "react";
import {APIPayment} from '../../../../../../API/api';
import {getAccessTokenSelector} from '../../../../../../redux/selectors/selectors';
import PayByCreditCard from "../../../../../../Components/payByCard/PayByCreditCard"
import {CheckoutForm} from "../../../../../../Components/checkOutForm/PaymentRequestButton"
import {useSelector} from "react-redux";
import { useTranslation } from 'react-i18next';
import {Elements} from "@stripe/react-stripe-js";
import {getStripe} from "../../../../../../payment/lazyStripe";



const PopupPayment = (props) => {

    const {modal, setModal, setModalActivePurchase, setModalActiveError} = props;
    const token = useSelector(getAccessTokenSelector)
    const { t } = useTranslation();
    const [stripe, setStripe] = useState(null);


    const closeModal = () => {
        setModal({
            show: false,
            data: null,
        })
    }
    useEffect(() => {
        if (modal.show) {
          getStripe().then(setStripe);
        }
      }, [modal.show]);

    const shouldShowElements = modal.show && stripe;


    return (
        <div
            className={modal.show ? "modalPayment active" : "modalPayment"} onClick={closeModal}>
            <div className={'modal-content-payment'}
                 onClick={e => e.stopPropagation()}>
                <div className={'close-and-feedback'}>
                    <div className={'leave-feedback'}>
                        <span>{t('payment-method')}</span>
                    </div>
                    <div className={'close-button'}>
                        <svg width="30" height="17" className={'close_icon'}
                             onClick={closeModal}
                             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.6416 12.0002L18.5804 7.07632C19.0069 6.61883 18.9948 5.90538 18.5522 5.46381C18.1097 5.0213 17.3972 5.00819 16.9397 5.43475L12.0001 10.3586L7.07621 5.42731C6.62059 4.96982 5.88089 4.96792 5.4234 5.42356C4.96591 5.87824 4.96402 6.61888 5.41965 7.07636L10.3584 12.0002L5.41965 16.924C4.9931 17.3815 5.00527 18.095 5.44778 18.5366C5.89029 18.9791 6.60278 18.9922 7.06029 18.5656L11.9841 13.6418L16.908 18.5656H16.9089C17.3617 19.0269 18.1033 19.0344 18.5655 18.5806C19.0267 18.1278 19.0342 17.3862 18.5805 16.9241L13.6416 12.0002Z"
                                fill="#003E47" fillOpacity="0.4"/>
                        </svg>
                    </div>
                </div>
                {modal.data.price && modal.data.name && modal.data.description && (
                    <div className={'set-of-paid'}>
                        <div className={'type-paid'}>
                            <span className={'set-service'}>{t(modal.data.description)} </span>
                            <span className={'type'}>{t(modal.data.name)}</span>
                        </div>
                        <span className={'price'}>{modal.data.price} €</span>
                    </div>
                )}
                {shouldShowElements && (
                    <Elements stripe={stripe}>
                        <>
                            <CheckoutForm
                                description={modal.data.description}
                                price={modal.data.price}
                                token={token}
                                id={modal.data.id}
                                name={modal.data.name}
                                closeModal={closeModal}
                                apiPaymentMethod={APIPayment.payCurrentPackage}
                                setModalActivePurchase={setModalActivePurchase}
                            />
                            <PayByCreditCard token={token}
                                             id={modal.data.id}
                                             closeModal={closeModal}
                                             apiPaymentMethod={APIPayment.payCurrentPackage}
                                             setModalActivePurchase={setModalActivePurchase}
                                             setModalActiveError={setModalActiveError}
                            />
                        </>
                    </Elements>
                )}
            </div>
        </div>
//                  </Elements>
    );
};

export default PopupPayment